var React = require('react');

function Report (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.77881 25.4212C6.77881 25.4212 8.47355 23.7265 13.5578 23.7265C18.642 23.7265 22.0314 27.116 27.1157 27.116C32.1999 27.116 33.8946 25.4212 33.8946 25.4212V5.08439C33.8946 5.08439 32.1999 6.77912 27.1157 6.77912C22.0314 6.77912 18.642 3.38965 13.5578 3.38965C8.47355 3.38965 6.77881 5.08439 6.77881 5.08439V25.4212Z","fill":"white","stroke":"white","strokeWidth":"3.38947","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6.77881 37.2841V25.4209","stroke":"white","strokeWidth":"3.38947","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Report.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = Report;

Report.default = Report;
